import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CodigosServicoRoutingModule } from './codigos-servico-routing.module';
import { CodigosServicoComponent } from './codigos-servico.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [CodigosServicoComponent],
  imports: [
    CommonModule,
    CodigosServicoRoutingModule,
    SharedModule]
})
export class CodigosServicoModule { }
